export const LOAD_PATIENT_LIST = 'patient/LOAD_PATIENT_LIST';
export const LOAD_PATIENT_LIST_SUCCESS = 'patient/LOAD_PATIENT_LIST_SUCCESS';
export const LOAD_PATIENT_LIST_ERROR = 'patient/LOAD_PATIENT_LIST_ERROR';

export const RESET_PATIENT_LIST = 'patient/RESET_PATIENT_LIST';

export const LOAD_PATIENT_DETAIL = 'patient/LOAD_PATIENT_DETAIL';
export const LOAD_PATIENT_DETAIL_SUCCESS =
  'patient/LOAD_PATIENT_DETAIL_SUCCESS';
export const LOAD_PATIENT_DETAIL_ERROR = 'patient/LOAD_PATIENT_DETAIL_ERROR';

export const CREATE_PATIENT = 'patient/CREATE_PATIENT';
export const CREATE_PATIENT_SUCCESS = 'patient/CREATE_PATIENT_SUCCESS';
export const CREATE_PATIENT_ERROR = 'patient/CREATE_PATIENT_ERROR';

export const UPDATE_PATIENT = 'patient/UPDATE_PATIENT';
export const UPDATE_PATIENT_SUCCESS = 'patient/UPDATE_PATIENT_SUCCESS';
export const UPDATE_PATIENT_ERROR = 'patient/UPDATE_PATIENT_ERROR';

export const LOAD_CURRENT_MANAGE_PATIENT_LIST =
  'patient/LOAD_CURRENT_MANAGE_PATIENT_LIST';
export const LOAD_CURRENT_MANAGE_PATIENT_LIST_SUCCESS =
  'patient/LOAD_CURRENT_MANAGE_PATIENT_LIST_SUCCESS';
export const LOAD_CURRENT_MANAGE_PATIENT_LIST_ERROR =
  'patient/LOAD_CURRENT_MANAGE_PATIENT_LIST_ERROR';
